import { ValidateJSModel } from 'forms/shared/types';
import address from 'forms/shared/validators/models/location/models/address';
import phoneModelValidator from 'forms/shared/validators/models/phone/phone';
import { isPVQForm } from 'helpers/form';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import { PsychologicalTreatmentTypeModel } from './TreatmentType';

const psychologicalTreatmentTypeValidator: ValidateJSModel<PsychologicalTreatmentTypeModel> = {

  Name: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && options?.requirePersonsName) {
      return {};
    }
    return { presence: true, hasValue: true };
  },

  HealthCareProviderFullName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)
      && options?.requirePersonsName
      && attributes?.HealthCareProviderFullNameNotApplicable?.applicable !== false) {
      return {
        presence: true,
        model: {
          validator: pvqNameModelValidator,
          requireMiddleName: false
        }
      };
    }
    return {};
  },

  HealthCareProviderFullNameNotApplicable: {},

  Phone: { presence: true, model: { validator: phoneModelValidator, requireNumber: true } },

  Address: (value, attributes, attributeName, options) => { //
    if (isPVQForm(options?.formType)) {
      return {
        presence: true, location: {
          requireStreet: true,
          validator: pvqLocationModelValidator
        }
      };
    }

    return {
      presence: true,
      location: {
        validator: address,
        allowPOBox: false,
      }
    };
  },

  Comments: {},
};

export default psychologicalTreatmentTypeValidator;
